module.exports = __webpack_public_path__ + "img/rigid_body0165.f03d84c9.gif";